import { StepSlug, type Store } from '@fiverr-private/store_builder_types';
import { STEP_CONFIGS, type StepGroups } from '../../constants/steps';

export const getAvailableSteps = (storeData?: Store): StepSlug[] =>
    STEP_CONFIGS.filter((config) => !config.condition || config.condition(storeData)).map((config) => config.slug);

export const getStepGroup = (stepSlug: StepSlug): StepGroups => {
    const config = STEP_CONFIGS.find((config) => config.slug === stepSlug);
    return config?.group || 'personalize';
};

export const getStepsByGroup = (group: StepGroups): StepSlug[] =>
    STEP_CONFIGS.filter((config) => config.group === group).map((config) => config.slug);
